import * as z from 'zod'
import type {
  ApprovedFunnelSummary,
  ApprovedFunnelTopic,
  ProducttypeName,
} from '@/api/approvedFunnels/types'

/*
 * PostgREST sagt keine Form zu, Spalten ändern sich mit Migrationen ohne
 * Ankündigung. Jede Antwort wird deshalb geprüft, genau wie bei der
 * Backend-API.
 */

export const approvedFunnelSummarySchema: z.ZodType<ApprovedFunnelSummary> = z.object({
  producttypeKey: z.string(),
  approvedTopicCount: z.number(),
  potentialSum: z
    .number()
    .nullable()
    .transform((value) => value ?? 0),
})

export const approvedFunnelTopicSchema: z.ZodType<ApprovedFunnelTopic> = z.object({
  id: z.number(),
  topic: z.string(),
  rankingPosition: z.number().nullable(),
  rankingScore: z.number().nullable(),
  rankingSearchVolume: z.number().nullable(),
  rankingMarginPerUnit: z.number().nullable(),
  createdAt: z.string(),
})

export const producttypeNameSchema: z.ZodType<ProducttypeName> = z.object({
  producttypeKey: z.string(),
  producttypeName: z.string().nullable(),
})
